import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import {
  Grid,
  Box,
  Stack,
  Button,
  IconButton,
  Typography,
  Avatar,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  CircularProgress,
  FormControlLabel,
  Tooltip,
  useTheme,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import ImageIcon from "@mui/icons-material/Image";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import HomeIcon from "@mui/icons-material/Home";

import { green } from "@mui/material/colors";
import Item from "../../Template/Item";
import WithPermission from "../../components/WithPermission";
import { TypeOf } from "zod";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  getPeopleProfile,
  updatePeopleProfile,
  updatePeopleProfilePicture,
  trashCustomfield,
} from "../../redux/actions/people.actions";
import { useParams } from "react-router";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Lightbox from "react-image-lightbox";
import Dilogbox from "../../components/Dilogbox";
//import "react-image-lightbox/style.css";

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
} from "react-image-crop";
//import 'react-image-crop/dist/ReactCrop.css'
import { canvasPreview } from "../../components/ImageCroper/canvasPreview";
import { useDebounceEffect } from "../../components/ImageCroper/useDebounceEffect";
import { confirm } from "react-confirm-box";
import { storeStateType, useAppDispatch } from "../../redux/store";
import { MailForm } from "./mail-form";
import { loadWorkTypes } from "../../redux/actions/schedule.actions";
import { checkStringFormat } from "../../utility";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import axios from "axios";
import { baseStyleType } from "../facility/facility-form";

function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number
) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: "%",
        width: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );
}

type CustomFieldsOnly = {
  id: number;
  field_label: string;
  field_slug: string;
  field_type: string;
  required_field: string;
  field_options?: string;
  file_extensions?: any;
  not_custom_fields?: boolean;
};

type selectOptionType = {
  label: string;
  value: string;
};

type FieldsName = {
  id?: number;
  field_label: string;
  field_slug: string;
  field_type: string;
  required_field: string;
  field_options?: selectOptionType[] | string;
  file_extensions?: any;
  not_custom_fields?: boolean;
  visa_type_options?: { label: string; value: string }[];
}[];

type customFieldsPair = {
  info_value: any;
  customfield: number;
  paramaters?: any;
  info_path?: any;
}[];

function randomNumberInRange(min: number, max: number) {
  // 👇️ get number between min (inclusive) and max (inclusive)
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// type ImgProps = {
//   alt: string;
//   src: string;
//   // add more HTML img attributes you need
// };

// const Img = (props: BoxProps & ImgProps) => (
//   <Box component="img" {...props} sx={{ width: 200 }} />
// );
const imageMimeTypes = /image\/png|image\/jpeg|image\/gif/;
const spreadSheetMimeTypes =
  /application\/msword|application\/vnd.openxmlformats-officedocument.wordprocessingml.document|application\/vnd.oasis.opendocument.text|text\/csv|text\/plain|text\/vnd.ms-excel|text\/vnd.openxmlformats-officedocument.spreadsheetml.sheet/;

const customOptions = {
  render: (message: any, onConfirm: any, onCancel: any) => {
    return (
      <Dilogbox
        isDialogOpened={true}
        handleConfirmDialog={onConfirm}
        handleCloseDialog={onCancel}
        message={message}
      />
    );
  },
};

export default function Peopleprofile() {
  const dispatch = useAppDispatch(); //useDispatch()
  const theme = useTheme();

  const { id } = useParams();
  const [pfields, setPfields] = useState<FieldsName>([]);
  const [mimetypes, setMimetypes] = useState([]);
  const [lightBox, setLightBox] = useState(false);
  const [photoIndex, setPhotoIndex] = useState("");
  const [imgSrc, setImgSrc] = useState("");
  const previewCanvasRef = useRef<HTMLCanvasElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const [scale] = useState(1);
  const [rotate] = useState(0);
  const [aspect, setAspect] = useState<number | undefined>();
  const [croppedImage, setCroppedImage] = useState<any | null>();
  const [cropped, setCropped] = useState(false);
  const profileUploderRef = useRef<any | null>(null);
  const infosArray: any = useMemo(() => [], []);
  const filePathArray: any = useMemo(() => [], []);
  const fileMimeTypeArray: any = useMemo(() => [], []);
  const infosDetailsArray: customFieldsPair = useMemo(() => [], []);
  const [infoData, setInfoData] = useState([]);
  const [attachedDoc, setAttachedDoc] = React.useState<number[]>([]);
  const [isOpenMail, setIsOpenMail] = React.useState(false);
  const [handelaction, setHandelaction] = React.useState("");
  const [userData, setUserData] = React.useState("");
  const [customRefFields, setCustomRefFields] = useState<CustomFieldsOnly[]>(
    []
  );

  const globalSettings = useSelector(
    (state: storeStateType) => state.sitesetting.settings
  );
  const worktypes = useSelector(
    (state: storeStateType) => state.schedule.work_types
  );
  const [, setFilePaths] = React.useState([]);
  const [infosDetails, setInfosDetails] = React.useState<customFieldsPair>([]);

  let workTypeOptions = useMemo(() => {
    return worktypes.map((worktype) => {
      return { label: worktype.name, value: worktype.id };
    });
  }, [worktypes]);

  const visaSelectOptions = React.useMemo(
    () => [
      { label: "Student Visa", value: "student-visa" },
      { label: "Permanent Resident", value: "permanent-resident" },
      { label: "Australian Citizen", value: "australian-citizen" },
      { label: "Other Visa Type", value: "other-visa-type" },
    ],
    []
  );

  const profileFields: FieldsName = useMemo(
    () => [
      {
        field_label: "Full Name",
        field_slug: "fullname",
        field_type: "text",
        required_field: "1",
        not_custom_fields: true,
      },
      {
        field_label: "Email Address",
        field_slug: "email",
        field_type: "text",
        required_field: "1",
        not_custom_fields: true,
      },
      {
        field_label: "Date of Birth",
        field_slug: "date_of_birth",
        field_type: "date",
        required_field: "1",
        not_custom_fields: true,
      },
      {
        field_slug: "address",
        field_label: "Address",
        field_type: "google_address",
        required_field: "1",
        not_custom_fields: true,
      },
      {
        field_slug: "mobile_number",
        field_label: "Mobile Number",
        field_type: "text",
        required_field: "1",
        not_custom_fields: true,
      },
      {
        field_slug: "is_active",
        field_label: "",
        field_type: "hidden",
        required_field: "0",
        not_custom_fields: true,
      },
      {
        field_slug: "visa_type",
        field_label: "Visa Type",
        field_type: "visa_type",
        visa_type_options: visaSelectOptions,
        required_field: "1",
        not_custom_fields: true,
      },
    ],
    [visaSelectOptions]
  );

  const { user, save, avatar, avatarSave } = useSelector(
    (state: any) => state.people
  );
  const uiloading = useSelector((state: any) => state.UI.loading);

  const useCustomFieldsDynamicSchema = (schema: any, config: any) => {
    const { field_slug, validationType, validations = [] } = config;
    if (!yup[validationType as keyof typeof yup]) {
      return schema;
    }
    const yupMethod = validationType as keyof typeof yup;
    let validator = yup[yupMethod] as Function;
    validator = validator();

    validations.forEach((validation: any) => {
      const { params, type } = validation;
      if (!validator[type as keyof typeof validator]) {
        return;
      }
      validator = validator[type as keyof typeof validator](...params);
    });
    schema[field_slug] = validator;
    return schema;
  };

  const useCustomFieldsExtendValidation = (customFields: any) => {
    return customFields.map((customField: any) => {
      switch (customField.field_type) {
        case "text":
        case "textarea":
        case "select":
          if (Number(customField.required_field) === 1) {
            return {
              ...customField,
              validationType: "string",
              validations: [
                {
                  type: "required",
                  params: ["This field is required"],
                },
              ],
            };
          } else {
            return customField;
          }
        case "multiple":
          if (Number(customField.required_field) === 1) {
            return {
              ...customField,
              validationType: "array",
              validations: [
                {
                  type: "min",
                  params: [1, "This field is required"],
                },
              ],
            };
          } else {
            return customField;
          }

        case "file":
          if (Number(customField.required_field) === 1) {
            return {
              ...customField,
              validationType: "mixed",
              validations: [
                {
                  type: "test",
                  params: [
                    "required",
                    "File is required",
                    (file: any) => {
                      // if (user[customField.field_slug]) {

                      //   return true;
                      // } else {
                      //   return file.length >= 1
                      // }
                      //user[opts.field_slug] = infosArray[opts.id]

                      return infoData[customField.id] === undefined
                        ? file && file.length >= 1
                        : true;
                    },
                  ],
                },
                {
                  type: "test",
                  params: [
                    "fileSize",
                    "File size too large, max file size is 5 Mb",
                    (file: any) => {
                      // if (user[customField.field_slug]) {
                      //   return true;
                      // } else {
                      //   return file.length >= 1 && file[0].size <= 1100000
                      // }
                      return infoData[customField.id] === undefined
                        ? file && file.length >= 1 && file[0].size <= 5000000
                        : true;
                    },
                  ],
                },
                {
                  type: "test",
                  params: [
                    "fileType",
                    "Incorrect file type",
                    (file: any) => {
                      // if (user[customField.field_slug]) {
                      //   return true;
                      // } else {
                      //   return file.length >= 1 && pextensions.includes(file[0].type as never)
                      // }
                      //return infoData[customField.id] === undefined ? file && file.length >= 1 && pextensions.includes(file[0].type as never) : true
                      const mime = mimetypes[customField.id]
                        ? mimetypes[customField.id]
                        : [];
                      return infoData[customField.id] === undefined
                        ? file &&
                            file.length >= 1 &&
                            mime.includes(file[0].type as never)
                        : true;
                    },
                  ],
                },
              ],
            };
          } else {
            return customField;
          }

        default:
          return customField;
      }
    });
  };

  const dynamicFormData = useCustomFieldsExtendValidation(pfields);
  const customFieldsSchema = dynamicFormData.reduce(
    useCustomFieldsDynamicSchema,
    {}
  );

  const dynamicValidationSchema = yup.object().shape(customFieldsSchema);

  const {
    formState: { errors },
    register,
    setError,
    watch,
    handleSubmit,
    control,
    reset,
  } = useForm<TypeOf<typeof customFieldsSchema>>({
    defaultValues: {},
    resolver: yupResolver(dynamicValidationSchema), // Here we use our dynamic schema
    mode: "onTouched",
  });

  useEffect(() => {
    dispatch<any>(getPeopleProfile(id));
  }, [dispatch, id]);

  useEffect(() => {
    dispatch<any>(loadWorkTypes());
  }, [dispatch]);
  useEffect(() => {
    let profileFieldCopy = [...profileFields];

    if (user) {
      if (user["visa_type"]) {
        let isOtherVisaType: boolean = true;
        visaSelectOptions.forEach((visaOption) => {
          if (visaOption.value === user["visa_type"]) {
            isOtherVisaType = false;
          }
        });
        if (isOtherVisaType) {
          let otherVisaValue = user["visa_type"];
          user.visa_type = "other-visa-type";
          user["other-visa-type"] = otherVisaValue;
        }
      }
      setUserData(user);

      //let infosArray: any = [];
      if (user.infos) {
        //const infos: customFieldsPair = JSON.parse(user.infos);
        const infos: customFieldsPair = user.infos;
        /* infos.map((c: any, i: number) => {
          infosArray[c.customfield] = c.info_value
        }) */
        infos.forEach((c) => {
          infosArray[c.customfield] = c.info_value;
          filePathArray[c.customfield] = c?.info_path || c.info_value;
          infosDetailsArray[c.customfield] = c;
        });
      }
      //console.log('Inofs Details Array', infosDetailsArray)

      setInfoData(infosArray);
      setFilePaths(filePathArray);
      setInfosDetails(infosDetailsArray);

      const tempFields: CustomFieldsOnly[] = [];
      const fileTypes: any = [];
      user.employeefields.forEach((opts: any) => {
        profileFieldCopy.push(opts);
        tempFields.push(opts);
        let mimeType: any = [];
        if (opts.file_extensions) {
          opts.file_extensions.split(",").forEach((ext: any) => {
            switch (ext) {
              case "jpg":
                //fileMimeTypeArray[opts.id] = ['image/jpg', 'image/jpeg']
                fileTypes.push("image/jpg");
                fileTypes.push("image/jpeg");
                mimeType.push("image/jpg");
                mimeType.push("image/jpeg");
                break;
              case "png":
                fileTypes.push("image/png");
                //fileMimeTypeArray[opts.id] = ['image/png']
                mimeType.push("image/png");
                break;
              case "gif":
                fileTypes.push("image/gif");
                //fileMimeTypeArray[opts.id] = ['image/gif']
                mimeType.push("image/gif");
                break;
              case "doc":
                fileTypes.push("application/msword");
                fileTypes.push(
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                );
                mimeType.push("application/msword");
                mimeType.push(
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                );
                //fileMimeTypeArray[opts.id] = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
                break;
              case "odt":
                fileTypes.push("application/vnd.oasis.opendocument.text");
                mimeType.push("application/vnd.oasis.opendocument.text");
                //fileMimeTypeArray[opts.id] = ['application/vnd.oasis.opendocument.text']
                break;
              case "pdf":
                fileTypes.push("application/pdf");
                mimeType.push("application/pdf");
                //fileMimeTypeArray[opts.id] = ['application/pdf']
                break;
              case "csv":
                fileTypes.push("text/csv");
                mimeType.push("text/csv");
                //fileMimeTypeArray[opts.id] = ['text/csv']
                break;
              case "text":
                fileTypes.push("text/plain");
                mimeType.push("text/plain");
                //fileMimeTypeArray[opts.id] = ['text/plain']
                break;
              case "xls":
                fileTypes.push("text/vnd.ms-excel");
                fileTypes.push(
                  "text/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                mimeType.push("text/vnd.ms-excel");
                mimeType.push(
                  "text/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                //fileMimeTypeArray[opts.id] = ['text/vnd.ms-excel', 'text/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
                break;
            }
          });

          fileMimeTypeArray[opts.id] = mimeType;
        }
        if (infosArray.length > 0) {
          if (infosArray[opts.id]) {
            if (opts.field_type === "multiple") {
              infosArray[opts.id] = infosArray[opts.id].split(",");
            }

            user[opts.field_slug] = infosArray[opts.id];
          }
        }
      });

      if (globalSettings) {
        let userRoles: selectOptionType[] = [];
        globalSettings.forEach((item: any) => {
          if (item["config_name"] === "site") {
            const configvalue = JSON.parse(item["config_value"]);
            if (configvalue) {
              userRoles = configvalue["user_role"]
                ?.split(/\r?\n/)
                ?.map((roleType: string) => {
                  return { label: roleType, value: roleType };
                });
            }
          }
        });

        profileFieldCopy.push({
          field_label: "User Role",
          field_slug: "user_role",
          field_type: "custom-select",
          field_options: userRoles,
          required_field: "1",
          not_custom_fields: true,
        });
        profileFieldCopy.push({
          field_label: "Work type",
          field_slug: "work_type",
          field_type: `custom-select`,
          field_options: workTypeOptions,
          required_field: `1`,
          not_custom_fields: true,
        });
      }

      setPfields(profileFieldCopy);
      setCustomRefFields(tempFields);
      setMimetypes(fileMimeTypeArray);
      reset(user);
    }
  }, [
    user,
    reset,
    fileMimeTypeArray,
    profileFields,
    filePathArray,
    infosArray,
    globalSettings,
    infosDetailsArray,
    workTypeOptions,
    visaSelectOptions,
  ]);

  useEffect(() => {
    if (avatar) dispatch<any>(getPeopleProfile(id));
  }, [avatar, dispatch, id]);

  const refsById = useMemo(() => {
    const refs: any[] = [];
    customRefFields.forEach((item: CustomFieldsOnly) => {
      refs[item.id] = React.createRef();
    });
    return refs;
  }, [customRefFields]);

  const onFormSubmit: SubmitHandler<TypeOf<typeof customFieldsSchema>> = (
    data
  ) => {
    const formdata = new FormData();
    let err = false;

    if (data["visa_type"] === "other-visa-type") {
      if (!data["other-visa-type"]) {
        err = true;
        setError("other-visa-type", {
          type: "manual",
          message: "Please enter other visa",
        });
      } else {
        formdata.append("other-visa-type", data["other-visa-type"]);
      }
    }
    if (err) {
      return false;
    }
    pfields.forEach((field, index) => {
      //if (data[field.field_slug] && field.not_custom_fields) {
      if (Object.hasOwn(data, field.field_slug) && field.not_custom_fields) {
        formdata.append(field.field_slug, data[field.field_slug]);
      }
    });

    const infos: customFieldsPair = [];
    data.employeefields.forEach((cfield: any) => {
      if (data[cfield.field_slug]) {
        if (data[cfield.field_slug] instanceof FileList) {
          for (const value of data[cfield.field_slug]) {
            formdata.append(cfield.field_slug, value);
            infos.push({
              info_value: value.name,
              customfield: cfield.id,
              paramaters: value.type,
            });
          }
        } else if (
          Array.isArray(data[cfield.field_slug]) &&
          data[cfield.field_slug].length > 0
        ) {
          infos.push({
            info_value: data[cfield.field_slug].join(","),
            customfield: cfield.id,
            paramaters: "",
          });
        } else if (
          cfield.field_type === "file" &&
          infoData[cfield.id] !== undefined
        ) {
          /* result = user.infos.map((info:any)) => {
            return info['customfield'] == cfield.id ?info['paramsters'] :''
          } */

          user.infos.forEach((info: any) => {
            if (info.customfield === cfield.id) {
              infos.push({
                info_value: data[cfield.field_slug],
                customfield: cfield.id,
                paramaters: info.paramaters,
              });
            }
          });

          //infosArray
          //infos.push({ info_value: data[cfield.field_slug], customfield: cfield.id, paramaters: '' })
        } else {
          infos.push({
            info_value: data[cfield.field_slug],
            customfield: cfield.id,
            paramaters: "",
          });
        }
      }
    });

    if (infos.length > 0) {
      formdata.append("infos", JSON.stringify(infos));
      data.infos = infos;
    }

    dispatch<any>(updatePeopleProfile(formdata, user.id));
  };

  const handleLightBox = (fileName: string) => {
    setPhotoIndex(fileName);
    setLightBox(true);
  };

  // Image Crop
  function onSelectFile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      setCrop(undefined); // Makes crop preview update between images.
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        setImgSrc(reader?.result?.toString() || "")
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, aspect));
    }
  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate
        ).then((c) => {
          const reader = new FileReader();
          c.toBlob((blob: any) => {
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              dataURLtoFile(
                reader.result,
                "avatr-" + user.id + randomNumberInRange(1, 9999)
              );
            };
          });
        });
      }
    },
    100,
    [completedCrop, scale, rotate]
  );

  function handleToggleAspectClick() {
    if (aspect) {
      setAspect(undefined);
    } else if (imgRef.current) {
      const { width, height } = imgRef.current;
      setAspect(16 / 9);
      setCrop(centerAspectCrop(width, height, 16 / 9));
    }
  }

  function dataURLtoFile(dataurl: any, filename: any) {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    const extension = mime.split("/").pop();
    filename = filename + "." + extension;

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    let cropped_image = new File([u8arr], filename, { type: mime });

    setCroppedImage(cropped_image);
  }

  const handleProfiePicSubmit = (e: any) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("avatar", croppedImage);
    dispatch<any>(updatePeopleProfilePicture(formData, user.id));
    setCropped(false);
    setCompletedCrop(undefined);
    setImgSrc("");
    profileUploderRef.current.value = null;
  };

  const handelProfilePicCancel = (e: any) => {
    e.preventDefault();
    setCropped(false);
    setCompletedCrop(undefined);
    setImgSrc("");
    profileUploderRef.current.value = null;
  };

  const handleTrash = async (option: any, id: any) => {
    const result = await confirm("Are you sure you want to delete?", option);
    if (result) {
      dispatch<any>(trashCustomfield(id, user.id));
      return;
    }
  };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = parseInt(event.target.value);
    if (event.target.checked) {
      setAttachedDoc((prevState) => [...prevState, value]);
    } else {
      setAttachedDoc((prevState) =>
        prevState.filter((prevItem) => prevItem !== value)
      );
    }

    /* const item = event.target.name
    const isChecked = event.target.checked
    setCheckedItems(prevState => {
      return new Map(prevState).set(item, isChecked);
    }); */
  };

  const handleClickOpen = () => {
    setIsOpenMail(!isOpenMail);
    setHandelaction("Send Mail");
  };

  const downloadFile = (filename: string, filePath: string) => {
    const element = document.createElement("a");
    element.href = filePath;
    element.download = filename;
    element.click();
  };

  const handleCloseMailForm = useCallback(() => {
    setIsOpenMail(false);
  }, []);

  let addressString = "";
  if (checkStringFormat(user?.address) === "json_object") {
    let addressObject = JSON.parse(user?.address);
    addressString = addressObject?.addressName;
  } else {
    addressString = user?.address;
  }

  function getGoogleAddressDefaultValue(value: string): string {
    if (checkStringFormat(value) === "json_object") {
      let addressObject = JSON.parse(value);
      return `${addressObject?.addressName}`;
    } else {
      return value;
    }
  }

  const customStyles: any = !errors["address"]
    ? {
        control: (baseStyles: baseStyleType) => ({
          ...baseStyles,
          backgroundColor: "transparent",
          padding: "5px 10px",
          zIndex: 2,

          borderRadius: 0,
          borderColor: `${theme.palette?.text.secondary}`,
          marginTop: "8px",
          marginLeft: "8px",
          boxShadow: 0,
        }),
        container: (provided: any) => ({
          ...provided,
          zIndex: 2,
          background: "transparent",
          color: "black", //this is the color of the drop down container text

          // Add your container styles here
        }),
        input: (provided: baseStyleType) => ({
          ...provided,
          padding: 0,
          margin: 0,
          marginLeft: "0px",
          color: theme?.palette?.text?.primary,
          zIndex: 2,
        }),
        dropdownContainer: (provided: any) => ({
          ...provided,
          backgroundColor: theme.palette.background.paper,
          zIndex: 2,
          // Add your dropdown container styles here
        }),
        dropdownItem: (provided: any) => ({
          ...provided,
          zIndex: 2,
          backgroundColor: theme.palette.background.paper,

          // Add your dropdown item styles here
        }),
        singleValue: (provided: baseStyleType) => ({
          ...provided,
          marginLeft: "0px",
          zIndex: 2,
          padding: 0,
          color: theme?.palette?.text?.primary, //selected text color
        }),
        item: (provided: baseStyleType) => ({
          ...provided,
          zIndex: 2,
          marginLeft: "0px",
          padding: 0,
        }),
      }
    : {
        control: (baseStyles: baseStyleType) => ({
          ...baseStyles,
          zIndex: 2,
          backgroundColor: "transparent",
          padding: "5px 10px",

          borderRadius: 0,
          borderColor: `${theme.palette?.error?.dark}`,
          boxShadow: 0,
        }),
        container: (provided: any) => ({
          ...provided,
          zIndex: 2,
          background: "transparent",
          color: "black", //this is the color of the drop down container text

          // Add your container styles here
        }),
        input: (provided: baseStyleType) => ({
          ...provided,
          marginLeft: "0px",
          padding: 0,
          zIndex: 2,
          margin: 0,
          color: theme?.palette?.text?.primary,
        }),
        dropdownContainer: (provided: any) => ({
          ...provided,
          backgroundColor: theme.palette.background.paper,
          zIndex: 2,
          // Add your dropdown container styles here
        }),
        dropdownItem: (provided: any) => ({
          ...provided,
          zIndex: 2,
          backgroundColor: theme.palette.background.paper,

          // Add your dropdown item styles here
        }),
        singleValue: (provided: baseStyleType) => ({
          ...provided,
          marginLeft: "0px",
          zIndex: 2,
          padding: 0,
          color: theme?.palette?.text?.primary, //selected text color
        }),
        item: (provided: baseStyleType) => ({
          ...provided,
          marginLeft: "0px",
          zIndex: 2,
          padding: 0,
        }),
      };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className="ouerLayer">
        <Item>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h6" m={2} mb={0} gutterBottom>
              Employee Profile
            </Typography>
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="flex-start"
            ></Box>
          </Stack>
          <Box sx={{ width: "100%" }}>
            <WithPermission
              roleReqiured={["ADMIN", "STAFF"]}
              message="Access Denied"
            >
              <Grid
                container
                spacing={2}
                display="flex"
                justifyContent={"center"}
              >
                <Grid item xs={2}>
                  <Item>
                    <form onSubmit={handleProfiePicSubmit}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems={"center"}
                        textAlign={"center"}
                      >
                        <IconButton>
                          <Avatar
                            alt={user?.fullname}
                            sx={{ width: 56, height: 56 }}
                            src={
                              user?.avatar
                                ? user.avatar
                                : "/static/images/avatar/2.jpg"
                            }
                          />
                        </IconButton>

                        <Typography variant="h6" gutterBottom component="div">
                          {user?.fullname}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          component="div"
                          display="flex"
                          flexWrap="nowrap"
                        >
                          <HomeIcon />
                          {addressString}
                        </Typography>

                        <div className="profileUploadcontainer">
                          <TextField
                            className="profileUploadOverlay"
                            id="contained-button-file"
                            fullWidth
                            inputProps={{
                              type: "file",
                              accept: "image/*",
                              sx: {
                                cursor: "pointer",
                              },
                            }}
                            onChange={onSelectFile}
                            inputRef={profileUploderRef}
                          />
                        </div>
                        {Boolean(imgSrc) && (
                          <ReactCrop
                            crop={crop}
                            onChange={(_, percentCrop) => setCrop(percentCrop)}
                            onComplete={(c) => {
                              setCompletedCrop(c);
                              setCropped(true);
                            }}
                            aspect={aspect}
                          >
                            <img
                              ref={imgRef}
                              alt="Crop me"
                              src={imgSrc}
                              style={{
                                transform: `scale(${scale}) rotate(${rotate}deg)`,
                              }}
                              onLoad={onImageLoad}
                            />
                          </ReactCrop>
                        )}

                        {cropped && (
                          <>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sx={{ mb: 1 }}>
                                <Button
                                  fullWidth
                                  variant="contained"
                                  onClick={handleToggleAspectClick}
                                  endIcon={<SendIcon />}
                                >
                                  Toggle aspect {aspect ? "off" : "on"}
                                </Button>
                              </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <Button
                                  fullWidth
                                  variant="contained"
                                  type="submit"
                                  startIcon={<SaveIcon />}
                                  color="success"
                                >
                                  Upload
                                </Button>
                              </Grid>
                              <Grid item xs={6}>
                                <Button
                                  fullWidth
                                  variant="contained"
                                  onClick={handelProfilePicCancel}
                                  startIcon={<DeleteIcon />}
                                  color="error"
                                >
                                  Cancel
                                </Button>
                              </Grid>
                            </Grid>
                          </>
                        )}
                        {avatarSave && (
                          <Stack alignItems="center">
                            <CircularProgress />
                          </Stack>
                        )}
                      </Box>
                    </form>
                    <Grid container spacing={2} sx={{ mt: "3px" }}>
                      <Grid item xs={6}>
                        {Boolean(completedCrop) && (
                          <canvas
                            ref={previewCanvasRef}
                            style={{
                              border: "1px solid black",
                              objectFit: "contain",
                              width: completedCrop?.width,
                              height: completedCrop?.height,
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>

                    {lightBox && (
                      <Lightbox
                        mainSrc={photoIndex}
                        onCloseRequest={() => setLightBox(false)}
                        onImageLoad={() => {
                          window.dispatchEvent(new Event("resize"));
                        }}
                      />
                    )}
                  </Item>
                </Grid>
                <Grid item xs={10}>
                  <Box
                    component="form"
                    sx={{
                      "& .MuiTextField-root": { m: 1 },
                    }}
                    noValidate
                    autoComplete="off"
                    onSubmit={handleSubmit(onFormSubmit)}
                  >
                    {uiloading && (
                      <Grid item md={12} xs={12} sx={{ mt: 5 }}>
                        <Stack alignItems="center">
                          <CircularProgress />
                        </Stack>
                      </Grid>
                    )}
                    {!uiloading && (
                      <>
                        <Item>
                          <Grid container spacing={1}>
                            {pfields.length > 0 &&
                              pfields.map((pfield, index) => {
                                if (pfield.field_type === "text")
                                  return (
                                    <Grid
                                      item
                                      md={6}
                                      xs={12}
                                      key={`grid-text-${index}`}
                                    >
                                      <TextField
                                        required={
                                          Number(pfield.required_field) === 1
                                            ? true
                                            : false
                                        }
                                        id={`fields-${index}`}
                                        label={pfield.field_label}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        fullWidth
                                        {...register(pfield.field_slug)}
                                        error={!!errors[pfield.field_slug]}
                                        helperText={
                                          errors[pfield.field_slug] &&
                                          errors[pfield.field_slug].message
                                        }
                                      />
                                    </Grid>
                                  );
                                if (pfield.field_type === "google_address")
                                  return (
                                    <Grid
                                      item
                                      md={6}
                                      xs={12}
                                      key={`grid-text-${index}`}
                                    >
                                      <FormControl
                                        fullWidth
                                        variant="standard"
                                        error={!!errors[pfield.field_slug]}
                                      >
                                        {/* <InputLabel
                                          htmlFor={pfield.field_label}
                                        >
                                          {pfield.field_label}
                                        </InputLabel> */}

                                        <Controller
                                          control={control}
                                          name={pfield.field_slug}
                                          render={({
                                            field: { onChange, value },
                                          }) => (
                                            <GooglePlacesAutocomplete
                                              apiKey={
                                                process.env
                                                  .REACT_APP_GOOGLE_AUTOCOMPLETE_KEY
                                              }
                                              selectProps={{
                                                placeholder: `${pfield.field_label}*`,
                                                defaultInputValue:
                                                  getGoogleAddressDefaultValue(
                                                    value
                                                  ),
                                                isClearable: true,

                                                onChange: (address: any) => {
                                                  function getAddressDetailInfo(
                                                    placeId: string,
                                                    setAddress: any
                                                  ) {
                                                    axios
                                                      .get(
                                                        `https://maps.googleapis.com/maps/api/geocode/json?place_id=${placeId}&key=${process.env.REACT_APP_GOOGLE_AUTOCOMPLETE_KEY}`
                                                      )
                                                      .then((res: any) => {
                                                        const addressComponents =
                                                          res?.data?.results[0]
                                                            ?.address_components ??
                                                          [];

                                                        // Extract address line
                                                        const addressLine =
                                                          addressComponents.find(
                                                            (component: any) =>
                                                              component.types.includes(
                                                                "street_number"
                                                              )
                                                          )?.long_name || "";

                                                        // Extract city
                                                        const city =
                                                          addressComponents.find(
                                                            (component: any) =>
                                                              component.types.includes(
                                                                "locality"
                                                              )
                                                          )?.long_name || "";

                                                        // Extract region
                                                        const region =
                                                          addressComponents.find(
                                                            (component: any) =>
                                                              component.types.includes(
                                                                "administrative_area_level_1"
                                                              )
                                                          )?.long_name || "";
                                                        // Extract postal code
                                                        const postalCode =
                                                          addressComponents.find(
                                                            (component: any) =>
                                                              component.types.includes(
                                                                "postal_code"
                                                              )
                                                          )?.long_name || "";
                                                        // Extract country
                                                        const country =
                                                          addressComponents.find(
                                                            (component: any) =>
                                                              component.types.includes(
                                                                "country"
                                                              )
                                                          )?.long_name || "";

                                                        const addressName =
                                                          res?.data?.results[0]
                                                            ?.formatted_address;
                                                        const addressObject = {
                                                          addressName,
                                                          addressLine,
                                                          postalCode,
                                                          country,
                                                          region,
                                                          city,
                                                        };
                                                        const detailAddress =
                                                          JSON.stringify(
                                                            addressObject
                                                          );
                                                        setAddress(
                                                          detailAddress
                                                        ); //set address to form address i.e. onchange
                                                      })
                                                      .catch(() =>
                                                        setAddress("")
                                                      );
                                                  }

                                                  if (address) {
                                                    getAddressDetailInfo(
                                                      address?.value?.place_id,
                                                      onChange
                                                    );

                                                    //i want to get postal code ,regions here
                                                  } else {
                                                    onChange("");
                                                  }
                                                },
                                                styles: customStyles,
                                              }}
                                            />
                                          )}
                                        />
                                        <FormHelperText id="facility_address_errror_message">
                                          {errors[pfield.field_slug]
                                            ? errors[pfield.field_slug].message
                                            : ""}
                                        </FormHelperText>
                                      </FormControl>

                                      {/* <TextField
                                        required={
                                          Number(pfield.required_field) === 1
                                            ? true
                                            : false
                                        }
                                        id={`fields-${index}`}
                                        label={pfield.field_label}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        fullWidth
                                        {...register(pfield.field_slug)}
                                        error={!!errors[pfield.field_slug]}
                                        helperText={
                                          errors[pfield.field_slug] &&
                                          errors[pfield.field_slug].message
                                        }
                                      /> */}
                                    </Grid>
                                  );

                                if (pfield.field_type === "date")
                                  return (
                                    <Grid
                                      item
                                      md={6}
                                      xs={12}
                                      key={`grid-date-${index}`}
                                    >
                                      <TextField
                                        required={
                                          Number(pfield.required_field) === 1
                                            ? true
                                            : false
                                        }
                                        id={`fields-${index}`}
                                        label={pfield.field_label}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        type="date"
                                        fullWidth
                                        {...register(pfield.field_slug)}
                                        error={!!errors[pfield.field_slug]}
                                        helperText={
                                          errors[pfield.field_slug] &&
                                          errors[pfield.field_slug].message
                                        }
                                      />
                                    </Grid>
                                  );

                                if (pfield.field_type === "textarea")
                                  return (
                                    <Grid
                                      item
                                      md={6}
                                      xs={12}
                                      key={`grid-textarea-${index}`}
                                    >
                                      <TextField
                                        required={
                                          Number(pfield.required_field) === 1
                                            ? true
                                            : false
                                        }
                                        id={`fields-${index}`}
                                        label={pfield.field_label}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        fullWidth
                                        multiline
                                        rows={3}
                                        {...register(pfield.field_slug)}
                                        error={!!errors[pfield.field_slug]}
                                        helperText={
                                          errors[pfield.field_slug] &&
                                          errors[pfield.field_slug].message
                                        }
                                      />
                                    </Grid>
                                  );
                                if (pfield.field_type === "select")
                                  return (
                                    <Grid
                                      item
                                      md={6}
                                      xs={12}
                                      key={`grid-select-${index}`}
                                    >
                                      <FormControl
                                        fullWidth
                                        variant="outlined"
                                        sx={{ mt: 1, ml: 1 }}
                                        error={!!errors[pfield.field_slug]}
                                      >
                                        <InputLabel id="role-select-label">
                                          {pfield.field_label}
                                        </InputLabel>
                                        <Controller
                                          name={pfield.field_slug}
                                          control={control}
                                          defaultValue=""
                                          render={({
                                            field: { onChange, value },
                                          }) => (
                                            <Select
                                              defaultValue=""
                                              labelId={pfield.field_slug}
                                              className="input-container"
                                              id={pfield.field_label}
                                              label={pfield.field_label}
                                              value={value}
                                              onChange={onChange}
                                            >
                                              {pfield.field_options &&
                                                typeof pfield?.field_options ===
                                                  "string" &&
                                                pfield?.field_options
                                                  .split(",")
                                                  .map((c: any, i: number) => (
                                                    <MenuItem
                                                      key={`c-${i}`}
                                                      value={c}
                                                    >
                                                      {c}
                                                    </MenuItem>
                                                  ))}
                                            </Select>
                                          )}
                                        />
                                        <FormHelperText>
                                          {errors[pfield.field_slug]
                                            ? errors[pfield.field_slug].message
                                            : ""}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  );
                                if (pfield.field_type === "custom-select")
                                  return (
                                    <Grid
                                      item
                                      md={6}
                                      xs={12}
                                      key={`grid-select-${index}`}
                                    >
                                      <FormControl
                                        fullWidth
                                        variant="outlined"
                                        sx={{ mt: 1, ml: 1 }}
                                        error={!!errors[pfield.field_slug]}
                                      >
                                        <InputLabel id="role-select-label">
                                          {pfield.field_label}
                                        </InputLabel>
                                        <Controller
                                          name={pfield.field_slug}
                                          control={control}
                                          defaultValue=""
                                          render={({
                                            field: { onChange, value },
                                          }) => (
                                            <Select
                                              defaultValue=""
                                              labelId={pfield.field_slug}
                                              // className="input-container"
                                              id={pfield.field_label}
                                              label={pfield.field_label}
                                              value={value}
                                              onChange={onChange}
                                            >
                                              {pfield.field_options &&
                                                Array.isArray(
                                                  pfield.field_options
                                                ) &&
                                                pfield.field_options.map(
                                                  (
                                                    c: selectOptionType,
                                                    i: number
                                                  ) => (
                                                    <MenuItem
                                                      key={`c-${i}`}
                                                      value={c.value}
                                                    >
                                                      {c.label}
                                                    </MenuItem>
                                                  )
                                                )}
                                            </Select>
                                          )}
                                        />
                                        <FormHelperText>
                                          {errors[pfield.field_slug]
                                            ? errors[pfield.field_slug].message
                                            : ""}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  );

                                if (pfield.field_type === "visa_type")
                                  return (
                                    <>
                                      <Grid
                                        item
                                        xs={12}
                                        ml={1}
                                        key={`grid-select-${index}`}
                                      >
                                        <FormControl
                                          fullWidth
                                          variant="outlined"
                                          error={!!errors[pfield.field_slug]}
                                        >
                                          <InputLabel id="role-select-label">
                                            {pfield.field_label}
                                          </InputLabel>
                                          <Controller
                                            name={pfield.field_slug}
                                            control={control}
                                            defaultValue=""
                                            render={({
                                              field: { onChange, value },
                                            }) => (
                                              <Select
                                                defaultValue="1"
                                                labelId={pfield.field_slug}
                                                className="input-container"
                                                id={pfield.field_label}
                                                key={pfield.field_label}
                                                label={pfield.field_label}
                                                sx={{ textAlign: "start" }}
                                                value={value}
                                                onChange={(value) => {
                                                  onChange(value);
                                                }}
                                              >
                                                {pfield.visa_type_options &&
                                                  pfield.visa_type_options.map(
                                                    (option: any) => {
                                                      return (
                                                        <MenuItem
                                                          key={`option-${option.value}`}
                                                          value={option.value}
                                                        >
                                                          {option.label}
                                                        </MenuItem>
                                                      );
                                                    }
                                                  )}
                                              </Select>
                                            )}
                                          />
                                        </FormControl>
                                      </Grid>
                                      {watch("visa_type") ===
                                        "other-visa-type" && (
                                        <Grid item xs={12}>
                                          <TextField
                                            required={true}
                                            id={`other-visa-text`}
                                            key={`other-visa-text`}
                                            label={"Other Visa"}
                                            type="text"
                                            fullWidth
                                            {...register("other-visa-type")}
                                            error={!!errors["other-visa-type"]}
                                            helperText={
                                              errors["other-visa-type"]
                                                ? errors["other-visa-type"]
                                                    .message
                                                : ""
                                            }
                                          />
                                        </Grid>
                                      )}
                                    </>
                                  );
                                if (pfield.field_type === "multiple")
                                  return (
                                    <Grid
                                      item
                                      md={6}
                                      xs={12}
                                      key={`grid-multiple-${index}`}
                                    >
                                      <Controller
                                        name={pfield.field_slug}
                                        control={control}
                                        defaultValue={[]}
                                        render={({ field }) => (
                                          <FormControl
                                            fullWidth
                                            variant="outlined"
                                            sx={{ mt: 1 }}
                                            error={!!errors[pfield.field_slug]}
                                          >
                                            <InputLabel id="age">
                                              {pfield.field_label}
                                            </InputLabel>
                                            <Select
                                              {...field}
                                              labelId="{field.field_slug"
                                              label="{field.field_label"
                                              multiple
                                              defaultValue={[]}
                                            >
                                              {pfield.field_options &&
                                                typeof pfield.field_options ===
                                                  "string" &&
                                                pfield.field_options
                                                  .split(",")
                                                  .map((c: any, i: number) => (
                                                    <MenuItem
                                                      key={`c-${i}`}
                                                      value={c}
                                                    >
                                                      {c}
                                                    </MenuItem>
                                                  ))}
                                            </Select>
                                            <FormHelperText>
                                              {errors[pfield.field_slug]
                                                ? errors[pfield.field_slug]
                                                    .messag
                                                : ""}
                                            </FormHelperText>
                                          </FormControl>
                                        )}
                                      />
                                    </Grid>
                                  );
                                if (pfield.field_type === "file")
                                  return (
                                    <Grid
                                      item
                                      md={12}
                                      xs={12}
                                      key={`grid-file-${index}`}
                                    >
                                      <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                          <FormControlLabel
                                            label=" Attach Document"
                                            key={`grid-checkbox-${index}`}
                                            control={
                                              <input
                                                type="checkbox"
                                                style={{
                                                  marginLeft: "19px",
                                                  marginRight: "10px",
                                                  padding: "2px",
                                                }}
                                                name={pfield.field_slug}
                                                className="form-check-input"
                                                disabled={
                                                  pfield?.id &&
                                                  infoData[pfield.id] ===
                                                    undefined
                                                    ? true
                                                    : false
                                                }
                                                onChange={handleCheckboxChange}
                                                value={pfield.id}
                                                ref={
                                                  refsById[
                                                    pfield.id !== undefined
                                                      ? pfield.id
                                                      : index
                                                  ]
                                                }
                                                //checked={checkedItems.get(pfield.field_slug)}
                                              />
                                            }
                                          />
                                        </Grid>
                                        <Grid item xs={12}>
                                          <TextField
                                            required={
                                              pfield.required_field === "1"
                                                ? true
                                                : false
                                            }
                                            id={`customfield-${index}`}
                                            label={pfield.field_label}
                                            type="file"
                                            fullWidth
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            {...register(pfield.field_slug)}
                                            error={!!errors[pfield.field_slug]}
                                            helperText={
                                              errors[pfield.field_slug] &&
                                              errors[pfield.field_slug].message
                                            }
                                          />
                                          <FormHelperText sx={{ ml: 2 }}>
                                            Allowed File Types:{" "}
                                            {pfield.file_extensions} Max file
                                            size: 5Mb
                                          </FormHelperText>
                                        </Grid>

                                        {user.employeefields.map(function (
                                          customfiled: any,
                                          index2: number
                                        ) {
                                          if (
                                            customfiled["field_slug"] ===
                                            pfield.field_slug
                                          ) {
                                            return (
                                              <>
                                                {user["infos"] &&
                                                  user["infos"].map(
                                                    (info: any) => {
                                                      if (
                                                        customfiled["id"] ===
                                                        info["customfield"]
                                                      ) {
                                                        if (
                                                          imageMimeTypes.test(
                                                            info["paramaters"]
                                                          ) &&
                                                          infosDetails[
                                                            pfield.id!
                                                          ] !== undefined
                                                        ) {
                                                          return (
                                                            <Grid item xs={12}>
                                                              <Grid
                                                                container
                                                                spacing={2}
                                                              >
                                                                <Grid
                                                                  item
                                                                  xs={6}
                                                                >
                                                                  <Tooltip
                                                                    title={
                                                                      infosDetails[
                                                                        pfield.id!
                                                                      ][
                                                                        "info_value"
                                                                      ]
                                                                    }
                                                                  >
                                                                    <Button
                                                                      onClick={() =>
                                                                        handleLightBox(
                                                                          infosDetails[
                                                                            pfield.id!
                                                                          ][
                                                                            "info_path"
                                                                          ]
                                                                        )
                                                                      }
                                                                      startIcon={
                                                                        <ImageIcon />
                                                                      }
                                                                    >
                                                                      {
                                                                        infosDetails[
                                                                          pfield.id!
                                                                        ][
                                                                          "info_value"
                                                                        ]
                                                                      }
                                                                    </Button>
                                                                  </Tooltip>
                                                                </Grid>
                                                                <Grid
                                                                  item
                                                                  xs={6}
                                                                >
                                                                  <Button
                                                                    color="error"
                                                                    onClick={() =>
                                                                      handleTrash(
                                                                        customOptions,
                                                                        customfiled[
                                                                          "id"
                                                                        ]
                                                                      )
                                                                    }
                                                                    startIcon={
                                                                      <DeleteIcon />
                                                                    }
                                                                  >
                                                                    Trash
                                                                  </Button>
                                                                </Grid>
                                                              </Grid>
                                                            </Grid>
                                                          );
                                                        }
                                                        if (
                                                          info["paramaters"] ===
                                                            "application/pdf" &&
                                                          infosDetails[
                                                            pfield.id!
                                                          ] !== undefined
                                                        ) {
                                                          return (
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              md={12}
                                                            >
                                                              <Grid
                                                                container
                                                                spacing={2}
                                                              >
                                                                <Grid
                                                                  item
                                                                  xs={6}
                                                                >
                                                                  <Tooltip
                                                                    title={
                                                                      infosDetails[
                                                                        pfield.id!
                                                                      ][
                                                                        "info_value"
                                                                      ]
                                                                    }
                                                                  >
                                                                    <Button
                                                                      component="a"
                                                                      href={
                                                                        infosDetails[
                                                                          pfield.id!
                                                                        ][
                                                                          "info_path"
                                                                        ]
                                                                      }
                                                                      target="_blank"
                                                                      startIcon={
                                                                        <ImageIcon />
                                                                      }
                                                                    >
                                                                      {
                                                                        infosDetails[
                                                                          pfield.id!
                                                                        ][
                                                                          "info_value"
                                                                        ]
                                                                      }
                                                                    </Button>
                                                                  </Tooltip>
                                                                </Grid>
                                                                <Grid
                                                                  item
                                                                  xs={6}
                                                                >
                                                                  <Button
                                                                    color="error"
                                                                    onClick={() =>
                                                                      handleTrash(
                                                                        customOptions,
                                                                        customfiled[
                                                                          "id"
                                                                        ]
                                                                      )
                                                                    }
                                                                    startIcon={
                                                                      <DeleteIcon />
                                                                    }
                                                                  >
                                                                    Trash
                                                                  </Button>
                                                                </Grid>
                                                              </Grid>
                                                            </Grid>
                                                          );
                                                        }

                                                        if (
                                                          spreadSheetMimeTypes.test(
                                                            info["paramaters"]
                                                          ) &&
                                                          infosDetails[
                                                            pfield.id!
                                                          ] !== undefined
                                                        ) {
                                                          return (
                                                            <Grid item xs={12}>
                                                              <Grid
                                                                container
                                                                spacing={2}
                                                              >
                                                                <Grid
                                                                  item
                                                                  xs={6}
                                                                  className="document_open_btn"
                                                                >
                                                                  <Tooltip
                                                                    title={
                                                                      infosDetails[
                                                                        pfield.id!
                                                                      ][
                                                                        "info_value"
                                                                      ]
                                                                    }
                                                                  >
                                                                    <Button
                                                                      onClick={() =>
                                                                        downloadFile(
                                                                          infosDetails[
                                                                            pfield.id!
                                                                          ][
                                                                            "info_value"
                                                                          ],
                                                                          infosDetails[
                                                                            pfield.id!
                                                                          ][
                                                                            "info_path"
                                                                          ]
                                                                        )
                                                                      }
                                                                      startIcon={
                                                                        <ImageIcon />
                                                                      }
                                                                    >
                                                                      {
                                                                        infosDetails[
                                                                          pfield.id!
                                                                        ][
                                                                          "info_value"
                                                                        ]
                                                                      }
                                                                    </Button>
                                                                  </Tooltip>
                                                                </Grid>
                                                                <Grid
                                                                  item
                                                                  xs={6}
                                                                >
                                                                  <Button
                                                                    color="error"
                                                                    onClick={() =>
                                                                      handleTrash(
                                                                        customOptions,
                                                                        customfiled[
                                                                          "id"
                                                                        ]
                                                                      )
                                                                    }
                                                                    startIcon={
                                                                      <DeleteIcon />
                                                                    }
                                                                  >
                                                                    Trash
                                                                  </Button>
                                                                </Grid>
                                                              </Grid>
                                                            </Grid>
                                                          );
                                                        } else {
                                                          return null;
                                                        }
                                                      } else {
                                                        return null;
                                                      }
                                                    }
                                                  )}
                                              </>
                                            );
                                          } else {
                                            return <></>;
                                          }
                                        })}
                                      </Grid>
                                    </Grid>
                                  );

                                if (pfield.field_type === "hidden")
                                  return (
                                    <input
                                      type="hidden"
                                      {...register(pfield.field_slug)}
                                      key={`form-hidden-${index}`}
                                    />
                                  );
                                else {
                                  return null;
                                }
                              })}
                          </Grid>
                        </Item>
                        <Item>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              p: 2,
                            }}
                          >
                            <Box sx={{ m: 1, position: "relative" }}>
                              <Button
                                type="submit"
                                variant="contained"
                                color="success"
                                startIcon={<SaveIcon />}
                                disabled={save}
                              >
                                Save
                              </Button>
                              {save && (
                                <CircularProgress
                                  size={24}
                                  sx={{
                                    color: green[500],
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    marginTop: "-12px",
                                    marginLeft: "-12px",
                                  }}
                                />
                              )}
                            </Box>

                            <Box sx={{ m: 1, position: "relative" }}>
                              <Button
                                disabled={attachedDoc.length === 0}
                                onClick={() => handleClickOpen()}
                                variant="contained"
                                color="secondary"
                                startIcon={<SendIcon />}
                              >
                                Send Attachment
                              </Button>
                            </Box>
                          </Box>
                        </Item>
                      </>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </WithPermission>
          </Box>
        </Item>
      </Grid>
      <MailForm
        isDialogOpened={isOpenMail}
        handleCloseDialog={handleCloseMailForm}
        action={handelaction}
        attachments={attachedDoc}
        customfields={pfields}
        user={userData}
        handleAttachments={(value: any) => {
          attachedDoc.forEach((vals) => {
            if (!value.includes(vals)) {
              if (refsById[value] !== undefined) {
                refsById[value].current.checked = false;
                /*
                const ref = refsById[value].current.name
                 setCheckedItems(prevState => {
                  return new Map(prevState).set(ref, false);
                }); */
              }
            }
          });
        }}
      />
    </Grid>
  );
}
